<ng-container *transloco="let convert;">
  <app-modal [modalId]="'postingSuccessModal'" id='postingSuccessModal' (keydown.escape)="closeAndRedirect('/inventory')">
    @if (postingType === postingTypes.EDIT) {
      <ng-content *ngTemplateOutlet="editSuccessContent"></ng-content>
    }
    @if (postingType === postingTypes.NEW) {
      <ng-content *ngTemplateOutlet="newPostingSuccessContent"></ng-content>
    }
    @if (postingType === postingTypes.REPOST_BEFORE_60_DAYS || postingType === postingTypes.REPOST_AFTER_60_DAYS) {
      <ng-content *ngTemplateOutlet="repostSuccessContent"></ng-content>
    }

    <ng-template #editSuccessContent>
      <div
        role="dialog"
        aria-modal="true"
        [attr.aria-label]="convert('sellModule.posting.postingSuccessModal.ariaLabelPostingSuccess')">
        <h1 class="modal__title" id="posting-success-title" tabindex="0">
          <div>
            <app-check-icon class="check-mark" fill="#00A664"></app-check-icon>
            {{convert('sellModule.posting.postingSuccessModal.textPostingUpdated')}}
          </div>
        </h1>
        <div class="modal__content">
          <div class="modal__body">
            <div>
              {{convert('sellModule.posting.postingSuccessModal.textChangesAppear')}}
            </div>
            <div class="modal__actions">
              <button
                class="btn btn-primary me-md-2 mb-3 mb-md-0"
                data-track-elem="button"
                data-track-name="Back to Manage Inventory"
                [attr.aria-label]="convert('sellModule.posting.postingSuccessModal.textManageInventory')"
                (click)="closeAndRedirect('/inventory')">
                {{convert('sellModule.posting.postingSuccessModal.textManageInventory')}}
              </button>
              <button
                class="btn cancel btn-link outline-focus ms-md-2"
                [attr.aria-label]="convert('common.btnClose')"
                (click)="close()">
                <span>{{convert('common.btnContinueEditing')}}</span>
              </button>
            </div>
          </div>
        </div>
        @if (configuration) {
          <button
            class="modal__close"
            data-dismiss="modal"
            [attr.aria-label]="convert('common.modalClose')"
            (click)="closeAndRedirect('/inventory')"
            data-track-elem="icon"
            data-track-name="Close"
            data-track-trigger="close">
            <img
              src="../../../../../ui/assets/assets-{{ configuration.tenantName }}/{{ configuration.tenantName }}-close.svg"
              alt="{{convert('common.altCloseModelIcon')}}"/>
          </button>
        }
      </div>
    </ng-template>
    <ng-template #newPostingSuccessContent>
      @if (warningContent) {
        <div class="error-item d-flex mb-3">
          <div class="error-icon me-2">
            <img
              class="image-exclamation"
              src="assets/icons/exclamation.svg"
              alt="error"
              />
          </div>
          <div class="title warning__content" tabindex='0'>
            <p [innerHTML]="warningContent"></p>
          </div>
        </div>
      }
      @if (!warningContent && inspectionType != newPostingInspectionOption.WAIT_FOR_INSPECTION) {
        <div>
          <header class="modal__header mb-4 d-flex align-items-center justify-content-center">
            <app-check-icon class="check-mark" fill="#00A664"></app-check-icon>
            <h1
              class="modal__title title ms-2 mb-0"
              id="new-post-success-modal-title"
              tabindex="0"
              >
              {{convert('sellModule.posting.postingSuccessModal.textNewPostingSuccessHeader')}}
            </h1>
          </header>
        </div>
      }
      @if (!warningContent && inspectionType != newPostingInspectionOption.WAIT_FOR_INSPECTION) {
        <div class="modal__content">
          <p
            class="modal__content--info text-center"
            >
            {{ content }}
          </p>
        </div>
      }
      @if (!warningContent && inspectionType == newPostingInspectionOption.WAIT_FOR_INSPECTION) {
        <div>
          <header class="modal__header mb-4 d-flex align-items-center justify-content-center">
            <app-error-icon class="error-icon me-2" fill="#D42925" [remValue]="'1.0rem'"></app-error-icon>
            <h1
              class="modal__title title ps-2 ms-2 mb-0"
              id="new-post-wait-for-inspection-success-modal-title"
              tabindex="0"
              >
              {{ heading }}
            </h1>
          </header>
        </div>
      }
      @if (!warningContent && inspectionType == newPostingInspectionOption.WAIT_FOR_INSPECTION) {
        <div class="modal__content">
          <p
            class="modal__content--info text-center"
            >
            {{ content }}
          </p>
        </div>
      }
      <div class="modal__actions">
        <button
          class="btn btn-primary me-md-2 mb-3 mb-md-0"
          data-track-elem="button"
          data-track-name="Go to Manage Inventory"
          [attr.aria-label]="convert('sellModule.posting.postingSuccessModal.textManageInventory')"
          (click)="closeAndRedirect('/inventory')">
          {{convert('sellModule.posting.postingSuccessModal.textManageInventory')}}
        </button>
        <button
          class="btn btn-link outline-focus me-md-2 mb-3 mb-md-0"
          data-track-elem="button"
          data-track-name="Post another vehicle"
          [attr.aria-label]="convert('sellModule.posting.postingSuccessModal.textPostAnotherVehicle')"
          (click)="closeAndRedirect('/inventory/post')">
          {{convert('sellModule.posting.postingSuccessModal.textPostAnotherVehicle')}}
        </button>
      </div>
    </ng-template>
    <ng-template #repostSuccessContent>
      @if (!warningContent) {
        <header class="modal__header mb-3 d-flex align-items-center justify-content-center">
          <app-check-icon class="check-mark" fill="#00A664"></app-check-icon>
          <h1
            class="modal__title repost title ms-2 mb-0"
            id="repost-success-modal-title"
            tabindex="0"
            >
            {{ heading }}
          </h1>
        </header>
      }
      @if (!warningContent) {
        <div class="modal__content">
          <p
            class="modal__content--info text-center"
            >
            {{ content }}
          </p>
        </div>
      }
      @if (warningContent) {
        <div class="error-item d-flex mb-3">
          <div class="error-icon me-2">
            <img
              class="image-exclamation"
              src="assets/icons/exclamation.svg"
              alt="error"
              />
          </div>
          <div class="warning__content">
            <p [innerHTML]="warningContent"></p>
          </div>
        </div>
      }
      <div class="modal__actions">
        <button
          class="btn btn-primary"
          [attr.aria-label]="convert('common.btnClose')"
          (click)="closeAndRedirect('/inventory')"
          >
          {{convert('common.btnClose')}}
        </button>
      </div>
      @if (!warningContent) {
        <div class="modal-close-container">
          <button
            class="modal__close"
            aria-label="Close modal"
            (click)="closeAndRedirect('/inventory')"
            data-track-elem="icon"
            data-track-name="Close"
            data-track-trigger="close"
            id="do_close_x_button"
            >
            <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
          </button>
        </div>
      }
    </ng-template>
  </app-modal>
</ng-container>
